import { render, staticRenderFns } from "./BillingMonth.vue?vue&type=template&id=2ed95327"
import script from "./BillingMonth.vue?vue&type=script&lang=js"
export * from "./BillingMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports